import { applyMiddleware } from 'redux';
import { createLogger } from 'redux-logger';
import thunk from 'redux-thunk';

// Set this flag to true/false to enable/disable logging (in dev only)
const ENABLE_LOGGER = true;

export default () => {
  const middleware = [];

  middleware.push(thunk);

  // Only log if not production AND the flag is set to true
  if (process.env.NODE_ENV !== 'production' && ENABLE_LOGGER) {
    middleware.push(
      createLogger({
        level: 'log',
        duration: true,
        collapsed: true,
        diff: true
      })
    );
  }
  return applyMiddleware(...middleware);
};
